import Serializable from "@/core/misc/mixins/Serializable";

class RpcDataSort extends Serializable {
    /** поле для сортировки */
    by: string;
    /** asc/desc */
    direction: string;

    static createDefault(): RpcDataSort {
        const obj     = new this();
        obj.by        = '';
        obj.direction = 'desc';
        return obj;
    }

    static fromRequest(data: Partial<RpcDataSort>): RpcDataSort | null {
        if (!data?.by) {
            return null;
        }

        const obj = new this();

        obj.by        = data.by;
        obj.direction = data.direction ?? 'desc';

        return obj;
    }
}

export default RpcDataSort;